angular.module("Main").directive("systeamValidation2", validation2);

function validation2() {
    var directive = {
        templateUrl: "./app/Main/controls/validation/validation2.html",
        restrict: "EA",
        replace: true,
        scope: {
            field: "=",
            icon: "@?"
        },
        controller: Validation2Controller,
        controllerAs: "vm",
        bindToController: true
    };
    return directive;
}

Validation2Controller.$inject = ["$scope", "$element"];

function Validation2Controller($scope, $element) {
    var vm = this;

    vm.showIcon = (vm.icon == "true" || _.isNil(vm.icon));

    $scope.$watch(function () {
        return [vm.field.$touched, vm.field.$valid, vm.field.$pending, vm.field.$error];
    }, function () {
        vm.isValidating = vm.field.$touched && !_.isNil(vm.field.$pending) && !_.isEmpty(vm.field.$pending);
        vm.isError = vm.field.$touched && !vm.field.$valid && !vm.isValidating;
        vm.isOk = vm.field.$touched && vm.field.$valid && !vm.isValidating;

        var validationElement = $element.prev();
        if (!_.isNil(vm.field.$error) && !_.isEmpty(vm.field.$error))
            vm.validationErrors = _.map(_.keys(vm.field.$error), function (value) {
                var attrName = _.kebabCase(value);
                var nodeValue = (!_.isNil(validationElement[0].attributes[attrName])) ? validationElement[0].attributes[attrName].nodeValue : null;
                return {error: value, value: (_.isNil(nodeValue)) ? "" : nodeValue};
            });
        else
            vm.validationErrors = [];
    }, true);
}